import endpoints from "@config/endpoints";
import { getDataWithCache, postDataJSON } from "@services/CommonApiService";
import { toast } from "react-toastify";
import { ABORTION_API_DETAILS, ABORTION_ERROR_MESSAGES } from "./AbortionConstants";

export const getServiceReportByParams = async (reportName: any) => {
    try {
        const res = await getDataWithCache<any>(`${endpoints.getServiceReportByParams}/${reportName}`);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(ABORTION_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(ABORTION_API_DETAILS.SERVICE_REPORT), {
            position: "top-center"
        });
    };
};

export const getAbortionDetailsById = async (pregnancyId: any) => {
    try {
        const res = await getDataWithCache<any>(`${endpoints.getAbortionDetailsById}/${pregnancyId}`);
        if (res && (res.data || res.data.length > 0)) {
            return res;
        }
    } catch (error: any) {
        toast.error(ABORTION_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(ABORTION_API_DETAILS.ABORTION_DETAILS), {
            position: "top-center"
        });
    };
};

export const createAbortion = async (payload: any) => {
    
    try {
        const res = await postDataJSON<any>(`${endpoints.createAbortion}`, payload);
        return res;
    } catch (error: any) {
        toast.error(ABORTION_ERROR_MESSAGES.POST_API_ERROR_MESSAGE(ABORTION_API_DETAILS.CREATE_ABORTION), {
            position: "top-center"
        });
    };
};